import { Fragment } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { TagInputField } from '@/shared/ui/form';
import { ArticlePersonIcon } from '@/shared/ui/Icons';

import { getBiographyItemLabel } from '../../../model';
import {
  FieldLabel,
  FormSection,
  FormSubsection,
  PersonaTextField,
} from '../../PersonaFormSections';
import { isFieldRequired, isNestedFieldRequired } from '../EditPersonaForm.schema';
import { useEditPersonaFormContext } from '../hooks/useEditPersonaFormContext';

export function BiographySection() {
  const { t } = useTranslation('audiences');

  const { control, biographyItemsArray } = useEditPersonaFormContext();
  const { fields } = biographyItemsArray;

  return (
    <FormSection icon={<ArticlePersonIcon />} title={t('audiences.biographySection.biography')}>
      <div className="flex flex-col gap-6">
        <Controller
          name="interests"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <TagInputField
              value={field.value}
              onChange={field.onChange}
              freeSolo
              label={t('audiences.biographySection.interests')}
              placeholder={t('audiences.biographySection.typeAndPressEnterTo')}
              required={isFieldRequired(field.name)}
              error={error?.message}
              options={[]}
            />
          )}
        />

        <FormSubsection>{t('audiences.biographySection.biographyItems')}</FormSubsection>

        <div className="grid grid-cols-[1fr_2fr] items-start gap-4">
          <FieldLabel required={isNestedFieldRequired('biographyItems', 'item')}>
            {t('audiences.biographySection.item')}
          </FieldLabel>
          <FieldLabel required={isNestedFieldRequired('biographyItems', 'description')}>
            {t('audiences.biographySection.description')}
          </FieldLabel>

          {fields.map((field, index) => (
            <Fragment key={field.id}>
              <p className="text-sm">{getBiographyItemLabel(fields[index].item)}</p>
              <Controller
                name={`biographyItems.${index}.description`}
                control={control}
                render={({ field: descField, fieldState: { error } }) => (
                  <PersonaTextField
                    {...descField}
                    aria-label={getBiographyItemLabel(fields[index].item)}
                    placeholder={t('audiences.biographySection.description')}
                    multiline
                    maxRows={8}
                    error={error?.message}
                  />
                )}
              />
            </Fragment>
          ))}
        </div>
      </div>
    </FormSection>
  );
}
